import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Pokemons Single Page Aplication',
        projectDesc: 'This solo project was done at the SoyHenry Academy to demonstrate what was learned in previous months. I used React, Redux, Node and PostgreSQL ',
        tags: ['React', 'Node', 'PostgreSQL'],
        code: '',
        demo: "https://pokemons-pi-h2i8-bjncwb4no-siriusgroza1413.vercel.app",
        image: one
    },
    {
        id: 2,
        projectName: '"La Dionisia" Wine E-Commerce',
        projectDesc: 'This group project was my last exam to pass the SoyHenry bootcamp, created with a lot of love by my project partners and me.',
        tags: ['NextJS', 'Tailwind CSS', 'ReduxToolkit', 'TS'],
        code: '',
        demo: "https://la-dionisia-front.vercel.app/",
        image: two
    },
    {
        id: 3,
        projectName: 'Weather App',
        projectDesc: 'Weather forecast doing as a homework at Henry Bootcamp',
        tags: ['React', 'CSS', 'Redux'],
        code: '',
        demo: '',
        image: three
    },
    {
        id: 4,
        projectName: 'Sirius Chat App',
        projectDesc: 'This project involves the development of Flutter chat application using Firebase',
        tags: ['Flutter', 'Dart', 'Firebase'],
        code: '',
        demo: '',
        image: four
    },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/